const confirmButton = document.getElementById('confirm');
const termsCheckbox = document.getElementById('terms');

const toggleClass = classname => element => element.classList.toggle(classname);

const toggleEvent = toggleClass('disabled');

const confirmation = () => {
	if(termsCheckbox && confirmButton) {
		termsCheckbox.addEventListener('change', e  => {		
			toggleEvent(confirmButton);
		});

		// onload check
		if(termsCheckbox.checked) {
			 confirmButton.classList.remove('disabled');	
		}

    }
}

export default confirmation; 
